export default "__VITE_ASSET__BZuUemMO__"